import { INotaryDetailsData } from 'types/signingAppointment/INotaryDetailsData';

export const sanitizeNotary = (notary: Partial<INotaryDetailsData>): INotaryDetailsData | undefined => {
  const sanitizedNotary: Partial<INotaryDetailsData> = {
    firstName: notary.firstName || '',
    lastName: notary?.lastName || '',
    email: notary?.email || '',
  };

  if (!sanitizedNotary.firstName && !sanitizedNotary.lastName && !sanitizedNotary.email) {
    return undefined;
  }

  return {
    ...notary,
    ...sanitizedNotary,
  } as INotaryDetailsData;
};
